export const WORD_CATEGORY_TREE = [
  {
    id: "everyday",
    name: "Everyday",
    children: [
      { id: "everyday.core", name: "Core Words" },
      { id: "everyday.home", name: "Home" },
      { id: "everyday.food", name: "Food" },
      { id: "everyday.travel", name: "Travel" },
      { id: "everyday.weather", name: "Weather" },
      { id: "everyday.colors", name: "Colors" },
      { id: "everyday.time", name: "Time" },
    ],
  },
  {
    id: "people",
    name: "People",
    children: [
      { id: "people.family", name: "Family" },
      { id: "people.body", name: "Body" },
      { id: "people.emotions", name: "Emotions" },
      { id: "people.professions", name: "Professions" },
    ],
  },
  {
    id: "education",
    name: "Education",
    children: [
      { id: "education.school", name: "School" },
      { id: "education.language", name: "Language" },
      { id: "education.math", name: "Math" },
      { id: "education.science", name: "Science" },
    ],
  },
  {
    id: "business",
    name: "Business",
    children: [
      { id: "business.office", name: "Office" },
      { id: "business.finance", name: "Finance" },
      { id: "business.trade", name: "Trade" },
      { id: "business.work", name: "Work" },
    ],
  },
  {
    id: "legal",
    name: "Legal",
    children: [
      { id: "legal.courts", name: "Courts" },
      { id: "legal.contracts", name: "Contracts" },
      { id: "legal.crime", name: "Crime" },
      { id: "legal.government", name: "Government" },
      { id: "legal.property", name: "Property" },
    ],
  },
  {
    id: "medical",
    name: "Medical",
    children: [
      { id: "medical.anatomy", name: "Anatomy" },
      { id: "medical.symptoms", name: "Symptoms" },
      { id: "medical.care", name: "Care" },
      { id: "medical.health", name: "Health" },
      { id: "medical.emergency", name: "Emergency" },
    ],
  },
  {
    id: "technology",
    name: "Technology",
    children: [
      { id: "technology.computers", name: "Computers" },
      { id: "technology.internet", name: "Internet" },
      { id: "technology.programming", name: "Programming" },
      { id: "technology.ai", name: "AI" },
    ],
  },
];

export const WORD_CATEGORY_SEEDS = {
  "everyday.core": [
    "time", "water", "people", "world", "day", "night", "thing", "place", "life", "way", "work", "word", "name", "hand", "head", "side", "room", "door",
  ],
  "everyday.home": [
    "house", "home", "room", "door", "window", "chair", "table", "bed", "wall", "floor", "garden", "roof", "kitchen", "bath", "family",
  ],
  "everyday.food": [
    "food", "water", "bread", "milk", "meat", "fruit", "sugar", "salt", "dinner", "breakfast", "tea", "wine", "drink", "eat", "taste",
  ],
  "everyday.travel": [
    "road", "street", "car", "train", "ship", "boat", "travel", "journey", "hotel", "airport", "map", "country", "city", "town", "village", "north", "south", "east", "west",
  ],
  "everyday.weather": [
    "weather", "rain", "snow", "wind", "sun", "sky", "cloud", "storm", "cold", "hot", "warm", "winter", "summer", "spring", "fall",
  ],
  "everyday.colors": [
    "red", "blue", "green", "black", "white", "yellow", "brown", "silver", "gold", "grey", "gray", "color", "colour",
  ],
  "everyday.time": [
    "time", "day", "night", "morning", "evening", "hour", "minute", "week", "month", "year", "today", "yesterday", "tomorrow", "january", "april", "september", "october", "november", "december",
  ],
  "people.family": [
    "family", "mother", "father", "son", "daughter", "child", "children", "wife", "husband", "brother", "sister", "parent", "cousin", "uncle",
  ],
  "people.body": [
    "body", "hand", "head", "face", "eye", "eyes", "mouth", "teeth", "nose", "hair", "heart", "blood", "skin", "feet", "leg", "legs", "arm", "breath", "brain",
  ],
  "people.emotions": [
    "love", "fear", "happy", "happiness", "joy", "anger", "grief", "hope", "pain", "surprise", "shame", "pride", "despair", "admiration",
  ],
  "people.professions": [
    "doctor", "teacher", "officer", "soldier", "minister", "writer", "author", "worker", "servant", "master", "judge", "lawyer", "scientist",
  ],
  "education.school": [
    "school", "student", "students", "teacher", "class", "study", "learn", "book", "read", "write", "lesson", "test", "question", "answer",
  ],
  "education.language": [
    "language", "word", "words", "letter", "sentence", "phrase", "grammar", "speak", "speech", "meaning", "noun", "verb", "english", "french", "german", "italian", "spanish",
  ],
  "education.math": [
    "number", "count", "sum", "square", "degree", "line", "point", "figure", "measure", "fraction", "equation", "total", "half", "hundred", "thousand", "million",
  ],
  "education.science": [
    "science", "scientific", "experiment", "energy", "temperature", "oxygen", "molecule", "metal", "iron", "stone", "earth", "nature", "machine", "system",
  ],
  "business.office": [
    "office", "paper", "letter", "message", "meeting", "account", "record", "report", "copy", "service", "company", "business",
  ],
  "business.finance": [
    "money", "pay", "paid", "cost", "value", "price", "dollar", "dollars", "credit", "fee", "refund", "stock", "trade", "profit", "loss",
  ],
  "business.trade": [
    "trade", "buy", "sell", "sold", "market", "goods", "supply", "produce", "product", "provide", "industry", "deal",
  ],
  "business.work": [
    "work", "worker", "job", "labor", "labour", "effort", "duty", "task", "service", "office", "company", "business",
  ],
  "legal.courts": [
    "law", "laws", "judge", "court", "justice", "trial", "evidence", "case", "sentence", "appeal", "prison", "prisoner",
  ],
  "legal.contracts": [
    "agreement", "contract", "terms", "condition", "permission", "license", "rights", "obligation", "promise", "trust", "copy", "copyright",
  ],
  "legal.crime": [
    "crime", "criminal", "guilty", "prison", "prisoner", "attack", "harm", "violent", "violence", "murder", "theft", "evidence",
  ],
  "legal.government": [
    "government", "state", "public", "authority", "nation", "united", "political", "policy", "civil", "citizen", "citizens", "official",
  ],
  "legal.property": [
    "property", "land", "owner", "possession", "estate", "house", "license", "rights", "title", "domain",
  ],
  "medical.anatomy": [
    "body", "heart", "blood", "skin", "brain", "teeth", "nose", "mouth", "eye", "eyes", "ear", "ears", "arm", "leg", "legs", "feet", "breath",
  ],
  "medical.symptoms": [
    "pain", "fever", "cold", "sick", "ill", "disease", "hurt", "wound", "broken", "weak", "tired", "blind",
  ],
  "medical.care": [
    "doctor", "hospital", "medicine", "medical", "care", "health", "treat", "treated", "help", "save", "relief",
  ],
  "medical.health": [
    "health", "healthy", "physical", "mental", "body", "clean", "safety", "safe", "strength", "life", "death",
  ],
  "medical.emergency": [
    "emergency", "danger", "death", "die", "blood", "attack", "wound", "save", "help", "fire", "accident",
  ],
  "technology.computers": [
    "computer", "machine", "data", "system", "program", "software", "hardware", "screen", "device", "digital", "code",
  ],
  "technology.internet": [
    "internet", "web", "website", "domain", "network", "online", "access", "link", "server", "browser",
  ],
  "technology.programming": [
    "code", "program", "function", "object", "class", "string", "array", "type", "source", "debug", "build",
  ],
  "technology.ai": [
    "ai", "model", "training", "learn", "language", "intelligence", "artificial", "prompt", "data", "neural",
  ],
};

export const WORD_CATEGORIES = Object.fromEntries(
  Object.entries(WORD_CATEGORY_SEEDS).map(([category, words]) => [
    category,
    new Set(words.map((word) => word.toLowerCase())),
  ])
);

export const WORD_CATEGORY_LABELS = Object.fromEntries(
  WORD_CATEGORY_TREE.flatMap((category) => [
    [category.id, category.name],
    ...(category.children || []).map((child) => [child.id, child.name]),
  ])
);

export const getCategoryLabel = (categoryId) => WORD_CATEGORY_LABELS[categoryId] || categoryId;
